import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import test from '@/components/test'
import index from '@/components/index'
// import userinfo from '@/components/userinfo'
// import help from '@/components/help'
// import edituserinfo from '@/components/edituserinfo'
// import bill from '@/components/bill'
// import withdraw from '@/components/withdraw'
// import tasklist from '@/components/tasklist'
// // import download from '@/components/download'
// import bindphone from '@/components/bindphone'
// import bindalipay from '@/components/bindalipay'
// import notice from '@/components/notice'
// import student from '@/components/student'
// import remain from '@/components/remain'
// import taskdetail from '@/components/taskdetail'
// import verify from '@/components/verify'
// import helpdetail from '@/components/helpdetail'
// import studentlist from '@/components/studentlist'
// import findaccout from '@/components/findaccout'

// const index = () => import('@/components/index')
const userinfo = () =>
    import ('@/components/userinfo')
const bill = () =>
    import ('@/components/bill')
const help = () =>
    import ('@/components/help')
const student = () =>
    import ('@/components/student')
const withdraw = () =>
    import ('@/components/withdraw')
const bindphone = () =>
    import ('@/components/bindphone')
const bindalipay = () =>
    import ('@/components/bindalipay')
const notice = () =>
    import ('@/components/notice')
const helpdetail = () =>
    import ('@/components/helpdetail')
const remain = () =>
    import ('@/components/remain')
const taskdetail = () =>
    import ('@/components/taskdetail')
const verify = () =>
    import ('@/components/verify')
const studentlist = () =>
    import ('@/components/studentlist')
const findaccout = () =>
    import ('@/components/findaccout')
const tasklist = () =>
    import ('@/components/tasklist')
const contact = () =>
    import ('@/components/contact')
const test = () =>
    import ('@/components/test')
const bindteacher = () =>
    import ('@/components/bindteacher')
const download = () =>
    import ('@/components/download')
const mytasklist = () =>
    import ('@/components/mytasklist')
const gametasklist = () =>
    import ('@/components/gametasklist')
const hbfl = () =>
    import ('@/components/hbfl')
const dytasklist = () =>
    import ('@/components/dytasklist')
const dytaskdetail = () =>
    import ('@/components/dytaskdetail')
const binddy = () =>
    import ('@/components/binddy')

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: index,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/hbfl',
            name: 'hbfl',
            component: hbfl,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/binddy',
            name: 'binddy',
            component: binddy,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/dytasklist',
            name: 'dytasklist',
            component: dytasklist,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/bindteacher',
            name: 'bindteacher',
            component: bindteacher,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/gametasklist',
            name: 'gametasklist',
            component: gametasklist,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/dytaskdetail',
            name: 'dytaskdetail',
            component: dytaskdetail,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/userinfo',
            name: 'userinfo',
            component: userinfo,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: contact,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/download/:teacherid',
            name: 'download',
            component: download,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/download',
            name: 'oridownload',
            component: download,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/bindphone',
            name: 'bindphone',
            component: bindphone,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/helpdetail',
            name: 'helpdetail',
            component: helpdetail,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/findaccout',
            name: 'findaccout',
            component: findaccout,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/studentlist',
            name: 'studentlist',
            component: studentlist,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/mytasklist',
            name: 'mytasklist',
            component: mytasklist,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/bindalipay',
            name: 'bindalipay',
            component: bindalipay,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/withdraw',
            name: 'withdraw',
            component: withdraw,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/notice',
            name: 'notice',
            component: notice,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/bill',
            name: 'bill',
            component: bill,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/help',
            name: 'help',
            component: help,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/tasklist',
            name: 'tasklist',
            component: tasklist,
            // beforeEnter: (to, from, next) => {
            //   console.log("Enter from:" + from.fullPath);
            //   console.log("Enter from:" + from.name);
            //   if (from.name == "index"){
            //     to.meta.keepAlive = false;
            //   } else {
            //     to.meta.keepAlive = true;
            //   }
            //   console.log("to.meta.keepAlive:" + to.meta.keepAlive);
            //   next();
            // },
            // beforeLeave: (to, from, next) => {
            //   console.log("to.fullPath:" + to.fullPath);
            //   console.log("to.name:" + to.name);
            //   from.meta.keepAlive = true;
            //   next();
            // },
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/tasklist_nocache',
            name: 'tasklist_nocache',
            component: tasklist,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/student',
            name: 'student',
            component: student,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/remain',
            name: 'remain',
            component: remain,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/taskdetail',
            name: 'taskdetail',
            component: taskdetail,
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/verify',
            name: 'verify',
            component: verify,
            meta: {
                keepAlive: false
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js